import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { SharedService } from 'src/app/core/services/shared.service';
import { AuthService } from 'src/app/core/services/auth.service';

@Component({
  selector: 'app-available-documents',
  templateUrl: './available-documents.component.html',
  styleUrls: ['./available-documents.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class AvailableDocumentsComponent implements OnInit {
  @Input() availableDocuments: any[];
  @Input() attachedDocuments: any[];
  @Input() folders: any[];
  @Input() candidateJobMatchFolders: any[];
  @Input() candidateId: string;
  @Output() onAttachDocuments = new EventEmitter<any>();
  @Output() saveCallback = new EventEmitter<any>();
  @Output() cancelCallback = new EventEmitter<any>();

  savingFlag = false;
  companyId: any;
  loadingFolders = false;
  skeletonPlaceholderFolders = [
    'width-50', 'width-75', 'width-25', 'width-50', 'width-75',
    'width-50', 'width-25', 'width-75', 'width-50', 'width-25'
  ];

  constructor(
    private authService: AuthService,
    private sharedService: SharedService
  ) { }

  ngOnInit() {
    this.savingFlag = false;
    this.companyId = this.authService.userDetails.company.companyId;
    this._setFolderDetails();
    if (this.attachedDocuments.length > 0) {
      const selectedCandidateDocumentIds = [];
      const selectedJobMatchDocumentIds = [];
      this.attachedDocuments.map(doc => {
        if (doc.isJobMatchDocument) {
          selectedJobMatchDocumentIds.push(doc.id);
        } else {
          selectedCandidateDocumentIds.push(doc.id);
        }
      });

      this._setDocumentSelectionToFolders(selectedCandidateDocumentIds, selectedJobMatchDocumentIds);
    } else {
      this.attachedDocuments = [];
      if (this.candidateJobMatchFolders.length > 0 || this.folders.length > 0) {
        this._setDocumentSelectionToFolders(null, null);
      }
    }
  }

  private _setFolderDetails() {
    this.folders = this.folders ? this.folders : [];
    if (this.candidateJobMatchFolders && this.candidateJobMatchFolders.length > 0) {
      this.candidateJobMatchFolders.map(jobMatch => {
        jobMatch.isJobMatchDocument = true;
        jobMatch.documents.map(document => {
          document.isJobMatchDocument = true;
        });
      });
    } else {
      this.candidateJobMatchFolders = [];
    }
  }

  attachDocuments() {
    this.onAttachDocuments.emit({ documents: this.attachedDocuments });
  }

  cancel() {
    if (this.cancelCallback) {
      this.cancelCallback.emit();
    }
  }

  private _setAttachedDocuments(file: any) {
    if (file.selected) {
      let checkIfDocExists = false;
      this.attachedDocuments.every(doc => {
        if (doc.id === file.id) {
          checkIfDocExists = true;
          return false;
        }
        return true;
      });

      if (!checkIfDocExists) {
        this.attachedDocuments.push(file);
      }
    } else {
      this.attachedDocuments = this.attachedDocuments.filter(doc => file.id != doc.id);
    }
  }

  private _checkAndSetDocumentsToSelected(selectedDocumentIds: any, documents: any[]) {
    documents.forEach(document => {
      document.selected = (selectedDocumentIds && selectedDocumentIds.includes((document.id))) ? true : false;
    });
  }

  private _checkIfAllDocumentsSelected(documents: any[]): boolean {
    let isAllParentDocumentsSelected = true;
    documents.every(document => {
      if (!document.selected) {
        isAllParentDocumentsSelected = false;
        return false;
      }
      return true;
    });
    return isAllParentDocumentsSelected;
  }

  private _setDocumentSelectionToFolders(selectedCandidateDocumentIds: any, selectedJobMatchDocumentIds: any) {
    if (this.candidateJobMatchFolders.length > 0) {
      this.candidateJobMatchFolders.map(folder => {
        if (folder.documents.length > 0) {
          this._checkAndSetDocumentsToSelected(selectedJobMatchDocumentIds, folder.documents);
        }
      });

      this.candidateJobMatchFolders.map(folder => {
        let isAllDocumentsSelected = true;
        if (folder.documents.length > 0) {
          isAllDocumentsSelected = this._checkIfAllDocumentsSelected(folder.documents);
        }
        folder.selected = isAllDocumentsSelected;
      });
    }

    if (this.folders.length > 0) {
      this.folders.map(parentFolder => {
        if (parentFolder.documents.length > 0) {
          this._checkAndSetDocumentsToSelected(selectedCandidateDocumentIds, parentFolder.documents);
        }

        if (parentFolder.folders.length > 0) {
          parentFolder.folders.map(childFolder => {
            if (childFolder.documents.length > 0) {
              this._checkAndSetDocumentsToSelected(selectedCandidateDocumentIds, childFolder.documents);
            }
          });
        }
      });

      this.folders.map(parentFolder => {
        let isAllParentDocumentsSelected = true;
        let isAllChildFolderDocumentsSelected = true;
        if (parentFolder.documents.length > 0) {
          isAllParentDocumentsSelected = this._checkIfAllDocumentsSelected(parentFolder.documents);
        }

        if (parentFolder.folders.length > 0) {
          parentFolder.folders.map(childFolder => {
            if (childFolder.documents.length > 0) {
              childFolder.selected = this._checkIfAllDocumentsSelected(childFolder.documents);
              if (!childFolder.selected) {
                isAllChildFolderDocumentsSelected = false;
              }
            }
          });
        }

        parentFolder.selected = (!isAllChildFolderDocumentsSelected || !isAllParentDocumentsSelected) ? false : true;
      });
    }
  }

  private _setAttachedDocumentsToFolders(file: any, folder: any) {
    let allDocumentsSelected = true;
    folder.documents.forEach(document => {
      if (file.id == document.id) {
        document.selected = file.selected;
      }

      if (!document.selected) {
        allDocumentsSelected = false;
      }
    });

    folder.selected = allDocumentsSelected;

    if (folder.parentFolderId) {
      this.folders.map(parentFolder => {
        if (parentFolder.id == folder.parentFolderId) {
          if (!allDocumentsSelected) {
            parentFolder.selected = allDocumentsSelected;
          } else {
            const isAllParentDocumentsSelected = this._checkIfAllDocumentsSelected(parentFolder.documents);
            parentFolder.selected = isAllParentDocumentsSelected;
          }
        }
      });
    }
  }

  selectFolderWithDocuments(folder: any) {
    const isFolderSelected = folder.selected;
    if (folder.documents.length > 0) {
      folder.documents.forEach(document => {
        document.selected = isFolderSelected;
        this._setAttachedDocuments(document);
      });
    }

    if (folder.folders.length > 0 && folder.folders[0].documents.length > 0) {
      folder.folders[0].selected = isFolderSelected;
      folder.folders[0].documents.forEach(document => {
        document.selected = isFolderSelected;
        this._setAttachedDocuments(document);
      });
    }

    if (folder.parentFolderId) {
      let isParentFolderAllDocumentsSelected = true;
      this.folders.every(parentFolder => {
        if (parentFolder.id == folder.parentFolderId) {
          if (parentFolder.documents.length > 0) {
            isParentFolderAllDocumentsSelected = this._checkIfAllDocumentsSelected(parentFolder.documents);
          }
          parentFolder.selected = isParentFolderAllDocumentsSelected && isFolderSelected ? true : false;
          return false;
        }
        return true;
      });
    }
  }

  getAndSetFolderToAttachedDocuments(file: any) {
    let folder: any = [];
    const folders = file.isJobMatchDocument ? this.candidateJobMatchFolders : this.folders;
    folders.map(parentFolder => {
      if (parentFolder.id === file.folderId) {
        folder = parentFolder;
      } else if (parentFolder.folders.length > 0) {
        parentFolder.folders.every(childFolder => {
          if (childFolder.id == file.folderId) {
            folder = childFolder;
            return false;
          }
          return true;
        });
      }
    });

    this._setAttachedDocumentsToFolders(file, folder);
  }

  selectAndDeselectDocument(file: any, folder?: any) {
    if (folder) {
      this._setAttachedDocuments(file);
      this._setAttachedDocumentsToFolders(file, folder);
    } else {
      file.selected = !file.selected;
      this._setAttachedDocuments(file);
      this.getAndSetFolderToAttachedDocuments(file);
    }
  }

  viewDocumentFIle(file: any) {
    this.sharedService.viewDocumentFile(file, (data: any) => {
    }, (error: any) => {
    });
  }
}
